<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-container fluid class="m-3">
                <b-row>
                    <b-col cols="12">
                        <div class="mb-3">
                            <strong class="text-sm text-md-md text-lg-lg">
                                BY CLICKING THE BOX AT THE END OF THIS DOCUMENT INDICATING YOUR ACCEPTANCE (THE “ACCEPTANCE”) OF THIS ENROLLMENT CONTRACT (THIS “AGREEMENT”), YOU AGREE YOU HAVE READ AND ARE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE WITH THIS AGREEMENT, YOU MUST NOT ACCEPT THIS AGREEMENT AND MUST NOT CONTINUE WITH COURSE REGISTRATION. DOING SO MEANS YOU START AN OFFICIAL WITHDRAWAL PROCESS. IF YOU ACCEPT THIS AGREEMENT, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD, AND ARE BOUND BY, THE TERMS AND CONDITIONS STATED HEREIN.
                            </strong>
                        </div>
                        <div class="mb-4">
                            <p>This Agreement is by and between you and BAY ATLANTIC UNIVERSITY (the “BAU”) / Mentora College and is effective as of the date of Acceptance (the “Effective Date”). It governs your academic and financial rights and responsibilities.</p>
                            <strong class="text-sm text-md-md text-lg-lg" v-if="form.active_module_start_date">
                                This Agreement Covers the Following Current Period of Attendance for the Program:
                                Period of Attendance Start Date: {{form.active_module_start_date}} Period of Attendance End Date: {{form.active_module_end_date}}
                            </strong>
                        </div>
                        <div>
                            <p class="font-weight-bold">SECTION A: VERIFICATION OF PERSONAL INFORMATION</p>
                            <p>The following information is pulled from the application form you submitted. If you need to update the information, you can click on the Edit Button.</p>
                        </div>

                        <b-row class="d-flex">
                            <!-- Kişisel Bilgiler -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card
                                    :title="$t('Your Personal Information')"
                                    class="h-100"
                                >
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="name"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                        <b-form-group :label="$t('name')">
                                            <b-form-input v-model="form.name" :disabled="true"/>
                                        </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="middle_name"
                                            rules=""
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('middle_name')">
                                                <b-form-input v-model="form.middle_name" :disabled="true" />
                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="surname"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                        <b-form-group :label="$t('last_name')">
                                            <b-form-input v-model="form.surname" :disabled="true" />
                                        </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="birthdate"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                        <b-form-group :label="$t('date_of_birth')">
                                            <select-date v-model="form.birthdate"/>
                                        </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="legal_presence_type"
                                            rules=""
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('legal_presence_type')">
                                                <parameter-selectbox
                                                    :disabled="true"
                                                    code="legal_presence_types"
                                                    :validateError="errors[0]"
                                                    v-model="form.legal_presence_type"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- ABD Adresi -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card
                                    :title="$t('us_contact_address')"
                                    class="h-100"
                                >
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="zipcode"
                                            rules=""
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('find_address_by_zip_code')">
                                                 <AddressSearchComponent
                                                     :required="false"
                                                     v-model="form.zipcode"
                                                     @selectedAddress="selected($event)"
                                                 />
                                                <b-form-invalid-feedback v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="apartment"
                                            rules=""
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('apartment_unit')">
                                                <b-form-input v-model="form.apartment" />
                                            </b-form-group>

                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>

                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="contact_address"
                                            :rules="isOnlineAndLegalPresenceTypeControl?'':'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('contact_address')">
                                                <b-form-textarea
                                                    v-model="form.contact_address"
                                                    max-rows="6"
                                                    rows="3"
                                                />

                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>

                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="contact_state_id"
                                            :rules="isOnlineAndLegalPresenceTypeControl?'':'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('state')">
                                                  <state-selectbox
                                                      :validateError="errors[0]"
                                                      v-model="form.contact_state_id"
                                                  />
                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="contact_city_id"
                                            :rules="isOnlineAndLegalPresenceTypeControl?'':'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('city')">
                                                <city-selectbox
                                                    v-model="form.contact_city_id"
                                                    :state_id="form.contact_state_id"
                                                    :validateError="errors[0]"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>

                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="contact_zip_code"
                                            :rules="isOnlineAndLegalPresenceTypeControl?'':'required'"
                                            v-slot="{ valid, errors }"
                                        >

                                            <b-form-group :label="$t('zip_code')">
                                                <b-form-input v-model="form.contact_zip_code" />

                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>

                                    </b-col>
                                </b-card>

                            </b-col>
                            <!-- Uluslararası Adres -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card
                                    :title="$t('Home Address (International Students)')"
                                    class="h-100"
                                >

                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="address"
                                            :rules="isOnlineAndLegalPresenceTypeControl?'required':''"
                                            v-slot="{ valid, errors }"
                                        >

                                            <b-form-group :label="$t('permanent_address')">
                                                <b-form-textarea
                                                    v-model="form.address"
                                                    max-rows="6"
                                                    rows="3"
                                                />

                                            </b-form-group>

                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>

                                    </b-col>
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="address_country_id"
                                            :rules="isOnlineAndLegalPresenceTypeControl?'required':''"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('country')">
                                                <country-selectbox
                                                    v-model="form.address_country_id"
                                                    @input="selectedCountryName($event)"
                                                />

                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>

                                    </b-col>
                                </b-card>

                            </b-col>

                            <!-- İletişim Bilgileri -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card
                                    :title="$t('Contact Information')"
                                    class="h-100"
                                >
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="personal_email"
                                            :rules="'required|email'"
                                            v-slot="{ valid, errors }"
                                        >

                                            <b-form-group :label="$t('personal_email')">
                                                <b-form-input v-model="form.personal_email" />

                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>

                                        </ValidationProvider>
                                    </b-col>

                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="mobile_tel"
                                            :rules="isOnlineAndLegalPresenceTypeControl?'':'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('gsm_no2')">
                                                <PhoneNumberInput
                                                    v-model="mobile_tel"
                                                    :validate-error="errors[0]"
                                                    :defaultCountryCode="form.countryCodeForm"
                                                    :no-flag="false"
                                                    @update="mobileTelUpdated"
                                                ></PhoneNumberInput>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                </b-card>
                            </b-col>

                            <!-- Acil Durum Kişisi -->
                            <b-col cols="12" md="6" lg="4" class="mb-3">
                                <b-card
                                    :title="$t('Emergency Contact Person')"
                                    class="h-100"
                                >
                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="emergency_person_name"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >

                                            <b-form-group :label="$t('name_surname')">
                                                <b-form-input v-model="form.emergency_person_name" />

                                            </b-form-group>

                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>

                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="emergency_person_relation"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >

                                            <b-form-group :label="$t('relationship')">
                                                <b-form-input v-model="form.emergency_person_relation" />

                                            </b-form-group>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>

                                        </ValidationProvider>
                                    </b-col>

                                    <b-col cols="12">
                                        <ValidationProvider
                                            name="emergency_person_phone"
                                            :rules="'required'"
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-group :label="$t('phone_number')">
                                                <PhoneNumberInput
                                                    v-model="form.emergency_person_phone"
                                                    :validate-error="errors[0]"
                                                    :no-flag="false"
                                                    @update="emergencyPhoneUpdate"
                                                ></PhoneNumberInput>

                                            </b-form-group>

                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                </b-card>
                            </b-col>
                        </b-row>

                        <!-- Onay kutusu ve Buton -->
                        <b-row class="mt-4">
                            <b-col cols="12">
                                <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                                    <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                                        <ValidationProvider
                                            name="status"
                                            rules="required"
                                            v-slot="{ valid, errors }"
                                        >
                                            <div class="d-flex flex-row-reverse">
                                                <b-form-checkbox
                                                    id="checkbox-ce-a"
                                                    v-model="form.status"
                                                    name="checkbox-ce-a"
                                                    value="accepted"
                                                    :unchecked-value="null"
                                                    class="text-sm text-md-md ml-4"
                                                >
                                                </b-form-checkbox>
                                                <p class="text-sm text-md-md">
                                                    I confirm that the information given in this section is true, complete, and accurate.
                                                </p>
                                            </div>
                                            <b-form-invalid-feedback v-if="errors[0]">
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" md="4" class="text-md-right mt-3">
                                        <b-button
                                            type="submit"
                                            @click="next"
                                            variant="primary"
                                            class="w-100 w-md-auto"
                                        >
                                            {{ $t('next') }}
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import StateSelectbox from "@/components/interactive-fields/StateSelectbox.vue";
import CountrySelectbox from "@/components/interactive-fields/CountrySelectbox.vue";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";
import AddressSearchComponent from "@/components/interactive-fields/AddressSearchComponent.vue";
import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
import SelectDate from "@/components/interactive-fields/SelectDate.vue";
import PhoneNumberInput from "@/components/elements/PhoneNumberInput.vue";
import StateService from "@/services/StateService";
import CountryService from "@/services/CountryService";
import CityService from "@/services/CityService";
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";

export default {
    components: {
        PhoneNumberInput,
        SelectDate,
        CitySelectbox,
        AddressSearchComponent,
        ParameterSelectbox,
        CountrySelectbox,
        StateSelectbox,
    },
    data() {
        return {
            form: {
                status: null,
            },
            registration_type_text: null,
            legalPresenceType: null,
            code: null,
            otherCode: null,
            emergencyCode: null,
            mobile_tel: null
        }
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        }),
        isOnlineAndLegalPresenceTypeControl() {
            return ['Online', 'F-1 Exchange', 'Exchange'].includes(this.registration_type_text) || ['Online', 'F-1 Exchange', 'Exchange'].includes(this.legalPresenceType)
        }
    },
    created() {
        this.getData()
    },
    methods: {
        selectedCountryName(value) {
            if (!value) return;
            const config = {
                params: {
                    sort: ('name'),
                    limit: -1
                }
            };
            CountryService.getAll(config)
                .then(response => {
                    const data = response?.data?.data || [];
                    const selectedData = data.find(item => item.id === value);
                    if (selectedData) {
                        this.form.address_country_name = selectedData.name;
                    }
                }).catch(() => {});
        },
        selectedCity(value) {
            if (!value || !this.form?.contact_state_id) return;
            CityService.getCity(this.form.contact_state_id)
                .then(response => {
                    const data = response?.data?.data || [];
                    const selectedData = data.find(item => item.id === value);
                    if (selectedData) {
                        this.form.contact_city_name = selectedData.name;
                    }
                }).catch(() => {});
        },
        selectedState(value) {
            if (!value) return;
            const config = {
                params: {
                    limit: -1
                },
            };
            this.options = [];
            StateService.getOptions(config)
                .then(response => {
                    const data = response?.data?.data || [];
                    const selectedData = data.find(item => item.id === value);
                    if (selectedData) {
                        this.form.contact_state_name = selectedData.name;
                    }
                }).catch(() => {});
        },
        async getData() {
            window.scrollTo(0,0)
            let user = await JSON.parse(localStorage.getItem('user'));
            const response = await EnrollmentAgreementForm.getStudentInformation(user.id)
            this.registration_type_text = response.data.data.registration_type_text
            this.legalPresenceType = response.data.data.legal_presence_type
            await this.$store.dispatch('enrollmentAgreementForm/saveFormData', response.data.data);
            this.form = {...this.formData}
            this.mobile_tel = (this.formData.mobile_tel_country_code ?? '') + this.formData.mobile_tel

        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                if (this.otherCode != null) {
                    this.form.home_tel_country_code = '+' + this.otherCode.countryCallingCode
                }
                if (this.emergencyCode != null) {
                    this.form.emergency_person_phone_country_code = '+' + this.emergencyCode.countryCallingCode
                }
                if (this.code != null) {
                    this.form.mobile_tel_country_code = '+' + this.code.countryCallingCode
                    this.form.countryCodeForm = this.code.countryCode
                } else {
                    this.form.mobile_tel_country_code = 1
                    this.form.countryCodeForm = 'US'
                }
                await this.$store.dispatch('enrollmentAgreementForm/saveFormData', this.form);
                await this.$emit('next', 1);
            }
        },
        mobileTelUpdated(event) {
            this.code = event
            this.form.mobile_tel = this.code.nationalNumber;
            this.form.mobile_tel_country_code = '+' + this.code.countryCallingCode
        },
        otherPhoneUpdate(event) {
            this.otherCode = event
            this.form.home_tel = this.otherCode.nationalNumber;
            this.form.home_tel_country_code = '+' + this.otherCode.countryCallingCode
        },
        emergencyPhoneUpdate(event) {
            this.emergencyCode = event
            this.form.emergency_person_phone = this.emergencyCode.nationalNumber;
            this.form.emergency_person_phone_country_code = '+' + this.emergencyCode.countryCallingCode
        },
        selected(event) {
            this.form.contact_state_id = event.state_id
            this.form.contact_city_id = event.city_id
            this.form.contact_zip_code = event.zip_code
            this.form.contact_address = event.street_number+' '+event.street_name
        },
    }
}
</script>
<style scoped>
.card-size {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 600px;
    height: auto;
    padding: 1rem;
    box-sizing: border-box;
}

.auto-height {
    height: auto !important;
}
</style>
